export const MODEL_NAME = 'warehouse';

export const TOP = 'top';
export const BOTTOM = 'bottom';
